<template>
  <div class="space-y-4">
    <BaseCard>
      <BaseCardBody clear-padding>
        <dl>
          <div class="px-4 py-5 sm:px-6 border-b sm:grid sm:grid-cols-4 sm:gap-4 sm:items-center">
            <dt class="text-sm font-medium text-gray-800">Issuer</dt>
          </div>
          <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6 sm:items-center">
            <dt class="text-sm font-medium text-gray-500">
              <img
                :src="account.logo"
                class="w-16 h-16 object-cover rounded-full mr-2 border inline-block"
              />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-3 space-y-1">
              <div>
                {{ account.name }}
              </div>
            </dd>
          </div>
          <div
            class="px-4 py-5 sm:px-6 border-b border-t sm:grid sm:grid-cols-4 sm:gap-4 sm:items-center"
          >
            <dt class="text-sm font-medium text-gray-800">Issuer Details</dt>
            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-3">
              <RegistrationPicker
                v-if="registrations.length > 0"
                :options="registrations"
                @select="setDetailsFromRegistration"
              />
            </dd>
          </div>
          <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6 sm:items-center">
            <dt class="text-sm font-medium text-gray-500">Name</dt>
            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-3">
              <ValidationProvider rules="required" name="issuer name" slim vid="issuerName">
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormInput v-model="inputIssuerName" class="w-2/3" />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
            </dd>
          </div>
          <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6 sm:items-center">
            <dt class="text-sm font-medium text-gray-500">Address</dt>
            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-3">
              <ValidationProvider name="issuer address" slim vid="issuerAddress">
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormInput v-model="inputIssuerAddress" class="w-2/3" />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
            </dd>
          </div>
          <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6 sm:items-center">
            <dt class="text-sm font-medium text-gray-500">Vat number</dt>
            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-3">
              <ValidationProvider name="issuer vat number" slim vid="issuerVatNumber">
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormInput v-model="inputIssuerVatNumber" class="w-1/2" />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
            </dd>
          </div>
          <div
            class="bg-white px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6 rounded-b sm:items-center"
          >
            <dt class="text-sm font-medium text-gray-500">Vat office</dt>
            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-3">
              <ValidationProvider name="issuer vat office" slim vid="issuerVatOffice">
                <template #default="{ errors }">
                  <BaseFormGroup>
                    <BaseFormInput v-model="inputIssuerVatOffice" class="w-1/2" />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </template>
              </ValidationProvider>
            </dd>
          </div>
        </dl>
      </BaseCardBody>
    </BaseCard>
  </div>
</template>

<script>
import RegistrationPicker from './RegistrationPicker.vue';

export default {
  components: {
    RegistrationPicker,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    issuerName: { type: String, required: true },
    issuerAddress: { type: String, default: '' },
    issuerVatNumber: { type: String, default: '' },
    issuerVatOffice: { type: String, default: '' },
    canChangeAccount: Boolean,
    canUpdateAccount: Boolean,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    account() {
      return this.$store.state.entities.accounts.byId[this.accountId];
    },
    registrations() {
      return (this.account?.registrations || []).map(
        (id) => this.$store.state.entities.accountRegistrations.byId[id]
      );
    },
    inputIssuerName: {
      get() {
        return this.issuerName;
      },
      set(issuerName) {
        this.update('issuer-name', issuerName);
      },
    },
    inputIssuerAddress: {
      get() {
        return this.issuerAddress;
      },
      set(issuerAddress) {
        this.update('issuer-address', issuerAddress);
      },
    },
    inputIssuerVatNumber: {
      get() {
        return this.issuerVatNumber;
      },
      set(issuerVatNumber) {
        this.update('issuer-vat-number', issuerVatNumber);
      },
    },
    inputIssuerVatOffice: {
      get() {
        return this.issuerVatOffice;
      },
      set(issuerVatOffice) {
        this.update('issuer-vat-office', issuerVatOffice);
      },
    },
  },
  created() {
    if (
      typeof this.account === 'undefined' ||
      this.account === null ||
      !('registrations' in this.account)
    ) {
      this.fetchaccount();
    } else {
      this.setDefaultDetails();
    }
  },
  methods: {
    update(prop, value) {
      this.$emit(`update:${prop}`, value);
    },
    setLoading(value) {
      this.loading = Boolean(value);
    },
    setDefaultDetails() {
      if (this.registrations.length > 0) {
        const [registration] = this.registrations;
        this.setDetailsFromRegistration(registration);
      } else {
        this.inputIssuerName = this.account.name;
      }
    },
    setDetailsFromRegistration(registration) {
      this.inputIssuerName = registration.businessName;
      this.inputIssuerAddress = registration.businessAddress;
      this.inputIssuerVatNumber = registration.number;
      this.inputIssuerVatOffice = registration.office;
    },
    async fetchaccount() {
      try {
        this.setLoading(true);
        await this.$store.dispatch({
          type: 'ui/accounts/getAccount',
          accountId: this.accountId,
          queryParams: {
            include: 'logo,registrations',
          },
        });
        this.setDefaultDetails();
      } catch (error) {
        //
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
